import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { customStyle } from 'helper';
import AddressRemove from 'modules/common/address/AddressRemove';
import * as actions from '../../../action';
import * as c from '../../../constant';

const quarterList = [
  { label: '1ST QUARTER', value: '1' },
  { label: '2ND QUARTER', value: '2' },
  { label: '3RD QUARTER', value: '3' },
  { label: '4TH QUARTER', value: '4' },
];

function ReclassificationDetails({
  formData,
  setFormData,
  validateForm,
  inquireMachineryApplication,
  transactionCode,
  getMachineryTaxEffectivityPeriod,
  taxEffectivityPeriod,
  getBarangayList,
  barangayList,
  getDistrictList,
  districtList,
  createRichTextEditor,
}) {
  const barangayOptions = barangayList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const districtOptions = districtList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const yearOptions = useMemo(
    () =>
      taxEffectivityPeriod.map((item) => ({
        label: item?.year,
        value: item?.year,
      })),
    [taxEffectivityPeriod]
  );

  const quarterOptions = useMemo(
    () =>
      taxEffectivityPeriod.find(
        (item) => item?.year === +formData?.tax_effectivity_year
      )?.quarter ?? []
  ).map(
    (item) => ({
      label: quarterList.find((qtr) => +qtr.value === +item)?.label,
      value: item,
    }),
    [taxEffectivityPeriod, formData?.tax_effectivity_year]
  );

  const handleOnChange = (e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleOnSearch = () => {
    inquireMachineryApplication(
      { tdn: formData.tdn, rptax_transaction_code_id: transactionCode },
      (res) => {
        const district = res?.data?.included?.buildingApplication
          ? res?.data?.included?.buildingApplication?.attributes
              ?.property_district_id
          : res?.data?.included?.landApplication?.attributes
              ?.property_district_id;
        setFormData({
          ...formData,
          machinery_application_id: res?.data?.id,
          pin: res?.data?.attributes?.pin ?? '',
          machinery_owner_name:
            res?.data?.included?.machineryOwner?.attributes?.full_name ?? '',
          land_application_id: res?.data?.included?.landApplication?.id ?? '',
          building_application_id:
            res?.data?.included?.buildingApplication?.id ?? '',
          property_barangay_id: res?.data?.included?.buildingApplication
            ? res?.data?.included?.buildingApplication?.attributes
                ?.property_barangay_id
            : res?.data?.included?.landApplication?.attributes
                ?.property_barangay_id,
          property_district_id: district,
          property_street: res?.data?.included?.buildingApplication
            ? res?.data?.included?.buildingApplication?.attributes
                ?.property_street
            : res?.data?.included?.landApplication?.attributes?.property_street,
        });
        getBarangayList({
          rptax_district_id: district,
        });
      }
    );
  };

  const handleOnChangeTaxPayerAddress = (e) => {
    setFormData({
      ...formData,
      property_region_id: e.target.value.region_code,
      property_province_id: e.target.value.province_code,
    });
  };

  useEffect(() => {
    getDistrictList({
      province_id: 65,
    });
  }, []);

  useEffect(() => {
    if (formData?.machinery_application_id) {
      getMachineryTaxEffectivityPeriod(formData?.machinery_application_id, {
        rptax_transaction_code_id: transactionCode,
      });
    }
  }, [formData?.machinery_application_id, transactionCode]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <div className="row">
      <div className="col-6 form-group">
        <label htmlFor="last_name" className="form-label mb-0">
          TDN/ARP No.
          {validateForm.renderMessage('tdn')}
        </label>
        <div className="input-group col-12 mt-2" style={{ marginLeft: -15 }}>
          <InputMask
            className="form-control"
            mask="aa-99999-99999"
            alwaysShowMask
            type="text"
            name="tdn"
            onChange={handleOnChange}
            value={_.get(formData, 'tdn') ?? ''}
          />
          <div className="input-group-append">
            <button
              disabled={
                _.get(formData, 'tdn') === '__-_____-_____' ||
                _.get(formData, 'tdn') === ''
              }
              type="button"
              onClick={handleOnSearch}
              className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
            >
              <span className="icon">
                <i className="fa fa-lg fa-search" />
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="col-6 form-group" />
      <div className="col-6 form-group pr-1">
        <label htmlFor="pin" className="form-label">
          PIN.
        </label>
        <input
          className="form-control text-uppercase"
          type="text"
          readOnly
          name="pin"
          onChange={handleOnChange}
          value={_.get(formData, 'pin') || ''}
        />
      </div>
      <div className="col-6 form-group pl-1">
        <label htmlFor="machinery_owner_name" className="form-label">
          Owner
        </label>
        <input
          className="form-control text-uppercase"
          type="text"
          readOnly
          name="machinery_owner_name"
          onChange={handleOnChange}
          value={_.get(formData, 'machinery_owner_name') || ''}
        />
      </div>
      <div className="col-12 mb-2">
        <div className="header-modal">Property Location</div>
      </div>
      <div className="col-12 form-group">
        <AddressRemove
          required
          value={{
            region_code: _.get(formData, 'property_region_id') || '',
            province_code: _.get(formData, 'property_province_id') || '',
          }}
          onChange={handleOnChangeTaxPayerAddress}
          region_name="property_region_id"
          province_name="property_province_id"
          name="tax_payer_address"
          withStreet={false}
          removeLabel
          isDisabled
        />
      </div>
      <div className="col-6 form-group pr-1">
        <label htmlFor="property_district_id" className="form-label mb-0">
          District
        </label>
        <Select
          options={districtOptions}
          isDisabled
          styles={customStyle}
          placeholder="Select District"
          value={
            districtOptions.filter(
              (item) =>
                +_.get(formData, 'property_district_id') === +_.get(item, 'id')
            ) || ''
          }
          onChange={() => {}}
        />
      </div>
      <div className="col-6 form-group pl-1">
        <label htmlFor="property_barangay_id" className="form-label mb-0">
          Barangay
        </label>
        <Select
          isDisabled
          options={barangayOptions}
          styles={customStyle}
          placeholder="Select Barangay"
          value={
            barangayOptions.filter(
              (item) =>
                +_.get(formData, 'property_barangay_id') === +_.get(item, 'id')
            ) || ''
          }
          onChange={() => {}}
        />
      </div>
      <div className="col-12 form-group">
        <label htmlFor="property_street" className="form-label mb-0">
          Unit No. / House No. / Street Name{' '}
          {validateForm.renderMessage('property_street')}
        </label>
        <input
          className="form-control text-uppercase"
          type="text"
          name="property_street"
          onChange={() => {}}
          value={_.get(formData, 'property_street') || ''}
          readOnly
        />
      </div>
      <div className="col-6 form-group pr-1">
        <label htmlFor="tax_effectivity_year" className="form-label mb-0">
          Tax Effectivity Year &nbsp;{' '}
          {validateForm.renderMessage('tax_effectivity_year')}
        </label>
        <Select
          options={yearOptions}
          styles={customStyle}
          placeholder="Select Year"
          value={yearOptions.find(
            (item) => item.value === _.get(formData, 'tax_effectivity_year')
          )}
          onChange={handleSelected('tax_effectivity_year')}
          isDisabled={_.isEmpty(formData?.machinery_application_id)}
        />
      </div>
      <div className="col-6 form-group pl-1">
        <label htmlFor="tax_effectivity_quarter" className="form-label mb-0">
          Tax Effectivity Quarter: &nbsp;{' '}
          {validateForm.renderMessage('tax_effectivity_quarter')}
        </label>
        <Select
          styles={customStyle}
          placeholder="Select Quarter"
          value={
            quarterOptions.filter(
              (item) =>
                `${item.value}` === _.get(formData, 'tax_effectivity_quarter')
            )[0]
          }
          options={quarterOptions}
          onChange={handleSelected('tax_effectivity_quarter')}
          isDisabled={
            formData?.tax_effectivity_year === '' ||
            formData?.tax_effectivity_year === undefined ||
            _.isEmpty(formData?.machinery_application_id)
          }
        />
      </div>
      <div className="col-12 form-group">
        {createRichTextEditor(
          { key: 'memoranda', label: 'Memoranda:' },
          { minLength: 3, required: true }
        )}
      </div>
    </div>
  );
}

ReclassificationDetails.defaultProps = {};

ReclassificationDetails.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
  transactionCode: PropTypes.string.isRequired,
  inquireMachineryApplication: PropTypes.instanceOf(Function).isRequired,
  getMachineryTaxEffectivityPeriod: PropTypes.instanceOf(Function).isRequired,
  taxEffectivityPeriod: PropTypes.instanceOf(Array).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxEffectivityPeriod:
    _.get(api, `${c.GET_MACHINERY_TAX_EFFECTIVITY_PERIOD}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICTS_LIST}.list`) || [],
  ownerList: _.get(api, `${c.GET_MACHINERY_OWNER}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ReclassificationDetails);
